export default "__VITE_ASSET__CRDvKJyK__"